import { Pipe, PipeTransform } from '@angular/core';

// Display hours as "Xh Ym" (e.g. 25.83 → "25h 50m"). Zero shows as "0h".
// Used everywhere Total Hours / Average Hours / similar decimal-hours values
// appear in the reporting UI (Phase 1 Pass D).
@Pipe({
    name: 'hoursMinutes',
    standalone: true
})
export class HoursMinutesPipe implements PipeTransform {
    transform(decimalHours: number | null | undefined): string {
        if (decimalHours == null || isNaN(decimalHours)) return '';

        const totalMinutes = Math.round(decimalHours * 60);
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;

        if (minutes === 0) return `${hours}h`;
        return `${hours}h ${minutes}m`;
    }
}
